/* MB Quick Add — add to cart via AJAX */
(function () {
  function updateCartCount(count) {
    document.querySelectorAll('.mb-cart-count, .cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function showToast(card, message) {
    const toast = card.querySelector('.mb-qa-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 2000);
  }

  async function addToCart(variantId, btn, card) {
    btn.classList.add('is-adding');
    const prevText = btn.textContent;
    btn.textContent = '...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!res.ok) throw new Error('Failed');

      // Get updated cart count
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      updateCartCount(cart.item_count);

      btn.textContent = '✓';
      showToast(card, 'Added to bag');

      // Try to open MB cart drawer if it exists
      if (typeof window.mbOpenCart === 'function') {
        setTimeout(() => window.mbOpenCart(), 300);
      }

      setTimeout(() => {
        btn.textContent = prevText;
        btn.classList.remove('is-adding');
      }, 1400);

    } catch (e) {
      btn.textContent = prevText;
      btn.classList.remove('is-adding');
      showToast(card, 'Please try again');
    }
  }

  // Event delegation — handles all cards
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.mb-qa-size, .mb-qa-btn');
    if (!btn || btn.disabled) return;

    // Don't propagate to the card link
    e.preventDefault();
    e.stopPropagation();

    const card = btn.closest('.mb-prod-card');
    const variantId = btn.dataset.variantId;
    if (!variantId || !card) return;

    addToCart(parseInt(variantId), btn, card);
  });

  // Prevent card link click when clicking inside the overlay
  document.addEventListener('click', function (e) {
    if (e.target.closest('.mb-qa-overlay')) {
      e.preventDefault();
    }
  });
})();
